import RestResource from '../rest.service';

export default class CommentsService extends RestResource {
  constructor() {
    super('document-comments');
  }
}
